import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';
import GoalsConstants from '../constants/Goals.constants';

function workspaces(state = [], action) {
  switch (action.type) {
    case 'WORKSPACES_GET_REQUEST':
      return state;
    case GoalsConstants.Actions.FETCH_SINGLE_GOAL_SUCCESS:
      if (isEmpty(action.payload.workspace)) return state;
      return uniqBy([...state, ...Object.values(action.payload.workspace).map(({ attributes }) => attributes)], 'id');
    case 'ADD_WORKSPACES_RESPONSE':
      return uniqBy([...action.payload.workspaces, ...state], 'id');
    case 'UPDATE_WORKSPACES_RESPONSE':
      return state.map(workspaceItem => {
        const updatedWorkspace = action.payload.workspaces.find(({ id }) => id === workspaceItem.id);
        if (updatedWorkspace) return { ...workspaceItem, ...updatedWorkspace };
        return workspaceItem;
      });
    case 'WORKSPACES_GET_RESPONSE':
      return action.data.workspaces;
    case GoalsConstants.Actions.CREATE_GOAL_SUCCESS:
    case GoalsConstants.Actions.UPDATE_GOAL_SUCCESS:
      return [
        ...state.filter(workspace => workspace.id !== Object.values(action.payload.workspace)[0].attributes.id),
        Object.values(action.payload.workspace)[0].attributes,
      ];
    case 'WORKSPACE_UPDATE_RESPONSE':
      return state.map(workspaceitem => {
        if (action.payload.id === workspaceitem.id) return { ...workspaceitem, ...action.payload.params };
        return workspaceitem;
      });
    case 'WORKSPACE_STARRED_SUCCESS':
    case 'WORKSPACE_UNSTARRED_SUCCESS':
      return state.map(workspace => {
        if (action.payload.id === workspace.id) return { ...workspace, ...action.payload };
        return workspace;
      });
    case 'WORKSPACE_UPDATES_GET_RESPONSE':
      return state.map(workspaceItem => {
        if (workspaceItem.id === action.payload.id) return { ...workspaceItem, ...action.payload };
        return workspaceItem;
      });
    case 'DELETE_WORKSPACE_RECURRENCE_RESPONSE':
    case 'SET_WORKSPACE_RECURRENCE_RESPONSE':
      return state.map(workspace => {
        if (workspace.id === action.payload.workspaceId)
          return {
            ...workspace,
            recurrence: action.payload.recurrence,
            manualNextEventDate: action.payload.manualNextEventDate,
          };
        return workspace;
      });
    case 'SET_CALENDAR_MEETING_REQUEST':
    case 'SET_CALENDAR_MEETING_RESPONSE':
    case 'SET_CALENDAR_MEETING_ERROR':
      return state.map(workspaceItem => {
        if (workspaceItem.id === action.payload.workspaceId)
          return { ...workspaceItem, calendarMeeting: action.payload.calendarMeeting };
        return workspaceItem;
      });
    case 'SET_RECURRING_MEETING_REQUEST':
    case 'SET_RECURRING_MEETING_RESPONSE':
    case 'SET_RECURRING_MEETING_ERROR':
      return state.map(workspaceItem => {
        if (workspaceItem.id === action.payload.workspaceId)
          return { ...workspaceItem, recurringMeeting: action.payload.recurringMeeting };
        return workspaceItem;
      });
    case 'RESET_WORKSPACE_NOTIFICATIONS':
    case 'WORKSPACE_NOTIFICATIONS_SYNC':
      return state.map(workspaceItem => {
        if (workspaceItem.id === action.payload.workspaceId)
          return { ...workspaceItem, workspaceNotifications: action.payload.workspaceNotifications };
        return workspaceItem;
      });
    default:
      return state;
  }
}

export default workspaces;
